export const convertFromLegacyMRI = (mri: string): string => {
    // Sometimes UPS service can return presence with a legacy MRI format.
    // This function normalizes the GUID format while preserving the cloud segment.
    // Examples:
    //   WW:   8:orgid:72f988bf86f141af91ab2d7cd011db47_631f7d8252064ec0a5bd49e9da46cbbf → 8:orgid:631f7d82-5206-4ec0-a5bd-49e9da46cbbf
    //   GCCH: 8:gcch:72f988bf86f141af91ab2d7cd011db47_631f7d8252064ec0a5bd49e9da46cbbf → 8:gcch:631f7d82-5206-4ec0-a5bd-49e9da46cbbf
    //   DOD:  8:dod:72f988bf86f141af91ab2d7cd011db47_631f7d8252064ec0a5bd49e9da46cbbf → 8:dod:631f7d82-5206-4ec0-a5bd-49e9da46cbbf
    return mri.replace(/8:(.*):.{32}_(.{8})(.{4})(.{4})(.{4})(.{12})/, "8:$1:$2-$3-$4-$5-$6");
};
